module.exports = ".materialization-in-list{\n  margin-left: -20px;\n  width: calc(100% + 20px);\n}\n.details {\n  margin-top: 30px;\n}\n"